import { ACTIONS_EVENT_NAMES, MAIN_PROVIDER_KEY } from './constatns';
import { emitter } from './emitter';
import { makeEventKey } from './helpers';

export function openModal({
  modalName,
  id,
  providerKey = MAIN_PROVIDER_KEY,
  props = {},
  onOpen,
  onClose,
}) {
  const eventKey = makeEventKey(providerKey, ACTIONS_EVENT_NAMES.open);

  emitter.emit(eventKey, {
    modalName,
    id: id || modalName,
    props,
    onOpen,
    onClose,
  });
}

export function closeModal({ modalName, id, providerKey = MAIN_PROVIDER_KEY }) {
  const eventKey = makeEventKey(providerKey, ACTIONS_EVENT_NAMES.close);

  emitter.emit(eventKey, {
    modalName,
    id,
  });
}

export function closeAllModals({ providerKey = MAIN_PROVIDER_KEY }) {
  const eventKey = makeEventKey(providerKey, ACTIONS_EVENT_NAMES.close);

  emitter.emit(eventKey);
}
